// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3UWKt","content":"LayoutSettings_content__3TJyS"};